import { selectIsLoggedIn, selectUser } from '../../store/user'
import { LogoutButton } from './LogoutButton'
import { RemoteImportExport } from './RemoteImportExport/RemoteImportExport'
import { GoogleLogin } from './GoogleLogin'
import React from 'react'
import { connect } from 'react-redux'

const LoginLogoutComponent = ({ isLoggedIn, email }) => {
    if (!isLoggedIn) {
        return (
            <>
                <p className="login-logout-description">Login to sync your list between devices.</p>
                <GoogleLogin />
                <RemoteImportExport />
            </>
        )
    } else {
        return (
            <>
                <p className="login-logout-description">Logged in as {email}</p>
                <LogoutButton />
                <RemoteImportExport />
            </>
        )
    }
}

function mapStateToProps(state) {
    const user = selectUser(state)

    return {
        isLoggedIn: selectIsLoggedIn(state),
        email: user?.email
    }
}

export const LoginLogout = connect(mapStateToProps)(LoginLogoutComponent)
